import * as components from './components'
import * as hooks from './hooks'

console.log('Shipping rules feature initialized!')

export { components, hooks }
